// Utilise toujours les mêmes mots pour tout le monde
// en se basant sur le jour UTC (pour que ce soit identique partout).

import words from "../data/words.json";

const EPOCH = Date.UTC(2024, 0, 1); // 1er janv 2024

function getDayIndex() {
  const now = Date.now();
  return Math.floor((now - EPOCH) / 86400000);
}

// On sépare les mots par longueur pour la suite 6/7/8/9
const wordsByLength = {};
words.forEach(w => {
  const len = w.length;
  if (!wordsByLength[len]) {
    wordsByLength[len] = [];
  }
  wordsByLength[len].push(w.toUpperCase());
});

function pseudoRandomIndex(day, salt, max) {
  // petit LCG suffisant pour mélanger
  const a = 1103515245 + salt * 97;
  const c = 12345 + salt * 31;
  const m = 2 ** 31;
  const v = (a * (day + 1) + c) % m;
  return v % max;
}

export function getDailyWord() {
  const day = getDayIndex();
  const list = words.map(w => w.toUpperCase());
  const idx = pseudoRandomIndex(day, 1, list.length);
  return list[idx];
}

export function getDailySuiteWords() {
  const day = getDayIndex();
  const lengths = [6, 7, 8, 9];
  return lengths.map((len, i) => {
    const list = wordsByLength[len] || [];
    if (!list.length) {
      throw new Error("Aucun mot de longueur " + len);
    }
    const idx = pseudoRandomIndex(day, 10 + i, list.length);
    return list[idx];
  });
}

export function getRandomWord() {
  const list = words.map(w => w.toUpperCase());
  const idx = Math.floor(Math.random() * list.length);
  return list[idx];
}

export function getCurrentDayIndex() {
  return getDayIndex();
}
